export const PROTOCOL_VERSION = 1;
export const LIMITS = {
    usernameMin: 1,
    usernameMax: 16,
    chatMax: 240,
    lobbyCodeLength: 6,
};
const NAME_PATTERN = /^[\p{L}\p{N} _.\-']+$/u;
/** Trims and validates a username. Returns null when unusable. */
export function normaliseUsername(raw) {
    if (typeof raw !== 'string')
        return null;
    const name = raw.trim().replace(/\s+/g, ' ');
    if (name.length < LIMITS.usernameMin || name.length > LIMITS.usernameMax)
        return null;
    if (!NAME_PATTERN.test(name))
        return null;
    return name;
}
export function normaliseLobbyCode(raw) {
    if (typeof raw !== 'string')
        return null;
    const code = raw.trim().toUpperCase().replace(/[^A-Z0-9]/g, '');
    return code.length === LIMITS.lobbyCodeLength ? code : null;
}
export function normaliseChat(raw) {
    if (typeof raw !== 'string')
        return null;
    const text = raw.replace(/\s+/g, ' ').trim();
    if (text.length === 0)
        return null;
    return text.slice(0, LIMITS.chatMax);
}
//# sourceMappingURL=protocol.js.map